import { render, staticRenderFns } from "./EntityAdditional.vue?vue&type=template&id=02b6208b"
import script from "./EntityAdditional.vue?vue&type=script&lang=js"
export * from "./EntityAdditional.vue?vue&type=script&lang=js"
import style0 from "./EntityAdditional.vue?vue&type=style&index=0&id=02b6208b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports